import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { resetNotificationListFiltersStore } from './reset-notification-list-filters-store';
var actions = {
  resetNotificationListFiltersStore: resetNotificationListFiltersStore,
  setCategoryFilter: function setCategoryFilter(categoryFilter) {
    return function (_ref) {
      var getState = _ref.getState,
        setState = _ref.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        categoryFilter: categoryFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setReadStateFilter: function setReadStateFilter(readStateFilter) {
    return function (_ref2) {
      var getState = _ref2.getState,
        setState = _ref2.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        readStateFilter: readStateFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setProductFilter: function setProductFilter(productFilter) {
    return function (_ref3) {
      var getState = _ref3.getState,
        setState = _ref3.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        productFilter: productFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setTimeRangeFilter: function setTimeRangeFilter(timeRangeFilter) {
    return function (_ref4) {
      var getState = _ref4.getState,
        setState = _ref4.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        timeRangeFilter: timeRangeFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setIncludeActorFilter: function setIncludeActorFilter(includeActorFilter) {
    return function (_ref5) {
      var getState = _ref5.getState,
        setState = _ref5.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        includeActorFilter: includeActorFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setExcludeActorFilter: function setExcludeActorFilter(excludeActorFilter) {
    return function (_ref6) {
      var getState = _ref6.getState,
        setState = _ref6.setState;
      var newFilters = _objectSpread(_objectSpread({}, getState().selectedFilters), {}, {
        excludeActorFilter: excludeActorFilter
      });
      setState({
        selectedFilters: newFilters
      });
    };
  },
  setCategoryFilters: function setCategoryFilters(categoryFilters) {
    return function (_ref7) {
      var setState = _ref7.setState;
      setState({
        categoryFilters: categoryFilters
      });
    };
  },
  setProductFilters: function setProductFilters(productFilters) {
    return function (_ref8) {
      var setState = _ref8.setState;
      setState({
        productFilters: productFilters
      });
    };
  }
};
export default actions;